import React, { useEffect } from 'react';
import SimpleReportDataTable from './SimpleReportDataTable';

const SimpleReportIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <SimpleReportDataTable rrhh={rrhh} />
    </>
  );
};

export default SimpleReportIndex;
